import { differenceInCalendarDays, isValid } from 'date-fns'
import { loadOrderParameters } from 'modules/setting/hooks'
import { Yup } from 'utils'

export const schema = Yup.object({
  unity: Yup.object({
    id: Yup.string().required()
  }).required(),
  customer: Yup.object({
    id: Yup.string().required()
  }).required(),
  purchaseOrder: Yup.string().max(12),
  representantOrderNumber: Yup.string(),
  requestedDate: Yup.date().nullable(),
  seller: Yup.object({
    id: Yup.string().required(),
    division: Yup.string().nullable()
  }).required(),
  paymentResponsible: Yup.object({
    id: Yup.string()
  }).required(),
  orderType: Yup.object({
    id: Yup.string().required(),
    name: Yup.string().required()
  }).required(),
  crossSale: Yup.object({
    id: Yup.string().required(),
    label: Yup.string().required()
  })
    .nullable()
    .required('Selecione uma opção de Venda Cruzada'),
  orderItems: Yup.array().min(1),
  totalInstallments: Yup.string(),
  paymentTerm: Yup.object({
    id: Yup.string().required()
  }).required(),
  installments: Yup.array().of(
    Yup.object({
      value: Yup.string(),
      paymentMethod: Yup.object({
        id: Yup.string().required()
      })
    })
  ),
  hasDirtRoadQuiz: Yup.object({
    id: Yup.string().required(),
    name: Yup.string()
  }).required(),
  dirtRoadQuizQuest1: Yup.string().when('hasDirtRoadQuiz', {
    is: (value: { id: string; name: string }) => {
      return value?.id === '1'
    },
    then: Yup.string().required(),
    otherwise: Yup.string()
  }),
  dirtRoadQuizQuest2: Yup.object().when('hasDirtRoadQuiz', {
    is: (value: { id: string; name: string }) => {
      return value?.id === '1'
    },
    then: Yup.object({
      id: Yup.string().required(),
      name: Yup.string()
    }).required(),
    otherwise: Yup.object({
      id: Yup.string(),
      name: Yup.string()
    }).nullable()
  }),
  dirtRoadQuizQuest3: Yup.object().when('hasDirtRoadQuiz', {
    is: (value: { id: string; name: string }) => {
      return value?.id === '1'
    },
    then: Yup.object({
      id: Yup.string().required(),
      name: Yup.string()
    }).required(),
    otherwise: Yup.object({
      id: Yup.string(),
      name: Yup.string()
    }).nullable()
  }),
  dirtRoadQuizQuest4: Yup.object().when('hasDirtRoadQuiz', {
    is: (value: { id: string; name: string }) => {
      return value?.id === '1'
    },
    then: Yup.object({
      id: Yup.string().required(),
      name: Yup.string()
    }).required(),
    otherwise: Yup.object({
      id: Yup.string(),
      name: Yup.string()
    }).nullable()
  }),

  deliveryAddressCompany: Yup.object().when('orderType', {
    is: (orderType: any) => orderType.id === 'V',
    then: Yup.object({
      id: Yup.string().required(),
      name: Yup.string()
    }).required(),
    otherwise: Yup.object({
      id: Yup.string(),
      name: Yup.string()
    }).nullable()
  }),

  // priceTable: Yup.object({
  //   id: Yup.string().required()
  // }).required()
  // carrier: Yup.object().when('freightType', {
  //   is: (freightType: any) =>
  //     freightType.name === 'CIF' || freightType.name === 'FOB',
  //   then: Yup.object({
  //     id: Yup.string(),
  //     name: Yup.string()
  //   }).required(),
  //   otherwise: Yup.object({
  //     id: Yup.string(),
  //     name: Yup.string()
  //   }).nullable()
  // }),
  // carrierRedispatch: Yup.object({
  //   id: Yup.string(),
  //   name: Yup.string()
  // }).nullable(),
  freightType: Yup.object({
    id: Yup.string().required(),
    name: Yup.string().required()
  }).required(),
  // budgetedFreightPrice: Yup.string().when('freightType', {
  //   is: (freightType: any) => freightType.name === 'CIF',
  //   then: Yup.string().required(),
  //   otherwise: Yup.string()
  // }),
  freightPrice: Yup.string().test(
    'freightPrice-isNumber',
    `Valor inválido!`,
    (value: any) => {
      return Number(value) >= 0
    }
  ),
  // deliveryDate: Yup.string(),
  observation: Yup.string().max(215),
  expeditionObs: Yup.string().max(251),
  opportunity: Yup.object({
    id: Yup.string()
  })
    .test(
      'has-proposal',
      ({ value }: any) =>
        `Oportunidade ${value?.id} está vinculada ao orçamento ${value?.proposalId}!`,
      (v: any, context: any) => {
        const currentProposalId = context?.parent?.proposalId
        const proposalId = v?.proposalId

        if (proposalId === currentProposalId) return true

        return !proposalId
      }
    )
    .test(
      'has-order',
      ({ value }: any) =>
        `Oportunidade ${value?.id} está vinculada ao pedido ${value?.orderId}!`,
      (v: any) => {
        const orderId = v?.orderId
        return !orderId
      }
    )
    .nullable(),
  totalDiscount: Yup.string()
    .test('totalDiscount-isNumber', `Valor inválido!`, (value) => {
      return Number(value) >= 0
    })
    .test(
      'max-reached',
      () => {
        return `Valor inválido!`
      },
      async (value) => {
        if (!value) return false
        const resp = await loadOrderParameters({})

        const limit = resp?.data?.find(
          (item: any) => item.orderId === 'MAX_DESC_FORA'
        ).orderDescription

        return +value < +limit
      }
    ),
  totalExpenses: Yup.string().test(
    'totalExpenses-isNumber',
    `Valor inválido!`,
    (value) => {
      return Number(value) >= 0
    }
  ),
  commissionPercent: Yup.number()
    .transform((_, originalValue) => {
      if (
        originalValue === '' ||
        originalValue === null ||
        typeof originalValue === 'undefined'
      ) {
        return 0
      }
      return Number(originalValue)
    })
    .min(0, 'O percentual de comissão deve ser entre 0 e 5.')
    .max(5, 'O percentual de comissão deve ser entre 0 e 5.')
    .nullable(),
  proposalValidity: Yup.date().test(
    'is-valid-range',
    'data inválida',
    function (proposalValidity: any, context: any) {
      const isDateValid = isValid(proposalValidity)

      const proposalValidityMaxDay = context?.parent?.proposalValidityMaxDay

      const lesserDate =
        differenceInCalendarDays(proposalValidity, new Date()) < 0

      const greaterDate =
        differenceInCalendarDays(proposalValidityMaxDay, proposalValidity) < 0

      if (lesserDate) return false

      if (greaterDate) return false

      return isDateValid
    }
  )
})
